import styled from 'styled-components';

export const CategorySection = styled.section`
  margin-top: 26px;
`;

export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
`;

export const CategoryTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CategoryName = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #2f3d48;
  line-height: 1.2;
`;

export const CategorySubtitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #172751;
  margin-top: 12px;
`;

export const CategoryNav = styled.div`
  display: flex;
  gap: 20px;
`;

export const CategoryArrow = styled.button`
  background: none;
  border: none;
  padding: 4px;
  color: #ff2d38;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  &:hover:not(:disabled) {
    opacity: 0.7;
  }
  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`;

export const CategoryScroller = styled.div`
  overflow-x: auto;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CategoryTrack = styled.div`
  display: flex;
  gap: 24px;
  > * {
    flex: 0 0 calc((100% - 48px) / 3);
    min-width: 250px;
    scroll-snap-align: start;
  }
`;
